import React from "react";
import { styled } from "@mui/material/styles";
import { IconButton as MuiIconButton, Tooltip } from "@mui/material";
import { useRecoilValue } from "recoil";
import { userState } from "../../../../states/userState";
import {
  foreColorCode,
  foreColorCodeOnMouseOver,
} from "../../../../commons/colors";

export const CustomIconButton = ({
  icon: Icon,
  caption = "",
  onClick,
  disabled = false,
  placement = "right",
}) => {
  const user = useRecoilValue(userState);

  const getStyles = () => ({
    backgroundColor: foreColorCode(user?.mode ?? "lite"),
    color: "#000",
    fontSize: 16,
    width: 30,
    height: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "3px 3px 8px 1px #202226",
    transition: "all 0.3s",
    "&:hover": {
      backgroundColor: foreColorCodeOnMouseOver(user?.mode ?? "lite"),
      color: "#37393F",
      boxShadow: "none",
      transform: "translate(3px, 3px)",
    },
    "&.Mui-disabled": {
      opacity: 0.5,
      boxShadow: "none",
      transform: "none",
    },
  });

  return (
    <Tooltip title={caption} placement={placement}>
      <MuiIconButton disabled={disabled} onClick={onClick} sx={getStyles()}>
        {/* アイコンはpropsから受け取ったコンポーネントを描画 */}
        {Icon && <Icon />}
      </MuiIconButton>
    </Tooltip>
  );
};
